// ANCHOR Graph State
import { node } from 'graph-state';
import { useGraphNodeDispatch, useGraphNodeValue } from 'react-graph-state';

export const signInErrorNode = node({
  key: 'signInError',
  get: '',
});

export function useSignInError() {
  return useGraphNodeValue(signInErrorNode);
}

export function useSignInErrorDispatch() {
  return useGraphNodeDispatch(signInErrorNode);
}
